import React, { useContext, useState, useEffect } from "react"
import { Main, Wrapper, StyledFlatList } from "./style"
import SingleFlat from "./SingleFlat"
import { ViewContext } from "../../../contexts/ViewContext"
import Loading from "../../Loading"
import { FlatsContext } from "../../../contexts/FlatsContext"

const FlatList = () => {
  const [displayType] = useContext(ViewContext)
  const [flats, loading, filteredFlats, setFilteredFlats] =
    useContext(FlatsContext)

  if (loading) {
    return (
      <Main>
        <Wrapper>
          <Loading />
        </Wrapper>
      </Main>
    )
  } else {
    return (
      <Main>
        <Wrapper style={{ width: "100%" }}>
          <StyledFlatList displayType={displayType}>
            {filteredFlats.map(flat => {
              const address = `${flat.baseData.address.address ? flat.baseData.address.address + "," : ""} ${
                flat.baseData.address.district ? flat.baseData.address.district + "," : ""
              } ${
                flat.baseData.address.city ? flat.baseData.address.city + "," : ""
              } ${flat.baseData.address.state ? flat.baseData.address.state : ""}`
              return (
                <SingleFlat
                  address={address}
                  description={
                    flat.baseData.description
                      ? flat.baseData.description
                      : "Nie podano"
                  }
                  transaction={flat.baseData.transaction}
                  price={flat.baseData.price}
                  pricePerBuildingMeter={flat.baseData.pricePerBuildingMeter}
                  pricePerLandMeter={flat.baseData.pricePerLandMeter}
                  key={flat.id}
                  floorage={
                    flat?.buildingInfo?.floorage ??
                    flat?.landData?.floorage ??
                    flat?.floorage
                  }
                  title={flat.baseData.meta.title}
                  image={flat.baseData.meta.ogPictureUrl}
                  urlId={flat.baseData.meta.urlId}
                />
              )
            })}
          </StyledFlatList>
        </Wrapper>
      </Main>
    )
  }
}

export default FlatList
